import * as Yup from 'yup';

export const validationSchema = Yup.object({
  fullName: Yup.string().required('Enter your full name!'),
  email: Yup.string().email('Invalid email format').required('Enter your email!'),
  // phoneNumber: Yup.string().required('Enter your phone number!'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters long')  // Password length validation
    .required('Enter your password!'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Confirm your password!'),
});
